import captureException from 'src/common/utils/captureException';
import { TripCartPrice } from 'src/common/types/TripCartPrice';
import apiFetch from 'src/pubsub/apiFetch';

export type PriceParams = {
  date?: string;
  duration: string;
  guests: string;
  captainOption: string;
  /**
   * It should be currency symbol. For example: `USD`
   */
  currency?: string;

};
const calculatePrices = async (
  boatId: string,
  params: PriceParams,
): Promise<TripCartPrice> => {
  const {
    date, duration, guests, captainOption, currency,
  } = params;
  const searchParams = new URLSearchParams({
    guests,
    captain_option: captainOption,
    duration,
  });

  if (currency) {
    searchParams.append('currency', currency);
  }

  if (date) {
    searchParams.append('start_date', date);
  }

  const url = `/boats/${boatId}/calculate_price/?${searchParams.toString()}`;
  try {
    const response = await apiFetch(url, {
      method: 'GET',
    });
    if (response.status === 200) {
      const priceData: TripCartPrice = await response.json();
      return priceData;
    }

    return {
      price_sections: [],
    };
  } catch (error) {
    captureException(error);
    return {
      price_sections: [],
    };
  }
};

export default calculatePrices;
